<template>
  <div class="d-flex flex-gap-1" :class="row ? 'flex-row' : 'flex-column'">
    <svg v-if="jpg" :width="width" :height="height" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.66667 5.8L6.66667 3.4L10 8.2H0L3.33333 4.9L4.66667 5.8Z" :fill="color"/>
      <ellipse cx="2.33337" cy="1.3" rx="1" ry="0.9" :fill="color"/>
    </svg>
    <svg v-if="png" :width="width" :height="height" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="0.600002" width="2" height="1.95" :fill="color"/>
      <rect x="4" y="2.55" width="2" height="1.95" :fill="color"/>
      <rect x="5.99994" y="0.600002" width="2" height="1.95" :fill="color"/>
      <rect x="8" y="2.55" width="2" height="1.95" :fill="color"/>
      <rect x="2" y="4.5" width="2" height="1.95" :fill="color"/>
      <rect x="5.99994" y="4.5" width="2" height="1.95" :fill="color"/>
      <rect y="6.45" width="2" height="1.95" :fill="color"/>
      <rect x="4" y="6.45" width="2" height="1.95" :fill="color"/>
      <rect x="8" y="6.45" width="2" height="1.95" :fill="color"/>
      <rect y="2.55" width="2" height="1.95" :fill="color"/>
    </svg>
    <svg v-if="pdf" :width="width" :height="height" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M1.2733 8.36224C1.06016 8.29129 0.888436 8.15425 0.794324 7.98C0.581082 7.62688 0.652163 7.27377 0.881808 6.97708C1.09833 6.69768 1.45701 6.46014 1.86272 6.26083C2.37662 6.01827 2.91984 5.82151 3.48336 5.67382C3.92098 5.01909 4.30885 4.34216 4.64471 3.64704C4.44391 3.26732 4.28647 2.87273 4.17448 2.46847C4.08044 2.10443 4.04435 1.74403 4.12418 1.4346C4.2062 1.11243 4.42381 0.823018 4.83499 0.685594C5.04495 0.615516 5.27241 0.576382 5.4933 0.615516C5.60442 0.635203 5.70888 0.675225 5.7991 0.732682C5.88932 0.790138 5.96305 0.863587 6.01493 0.947701C6.11116 1.09696 6.14615 1.27169 6.15381 1.43733C6.16146 1.60752 6.14068 1.79682 6.10241 1.99613C6.01055 2.46028 5.80715 3.02818 5.53376 3.62884C5.83546 4.16581 6.19411 4.67932 6.60544 5.16326C7.09218 5.13126 7.58174 5.14653 8.06424 5.20876C8.46229 5.26792 8.8669 5.38623 9.11404 5.63196C9.24527 5.76301 9.3251 5.92319 9.33275 6.10339C9.34041 6.27812 9.28136 6.45104 9.18184 6.61577C9.09564 6.76842 8.96199 6.89913 8.79473 6.99437C8.62939 7.08413 8.43418 7.12809 8.23702 7.11996C7.87505 7.10722 7.52184 6.94158 7.21674 6.74045C6.84577 6.48514 6.51148 6.19502 6.22051 5.87586C5.481 5.94567 4.75026 6.06931 4.0367 6.24536C3.70955 6.72769 3.33617 7.18727 2.92018 7.6196C2.60305 7.93814 2.25531 8.21571 1.90756 8.33585C1.70775 8.41107 1.48112 8.4205 1.2733 8.36224V8.36224ZM2.7813 6.63215C2.59977 6.70132 2.43137 6.77413 2.27936 6.84875C1.92068 7.02531 1.68775 7.19732 1.57184 7.34658C1.46904 7.47854 1.46686 7.5741 1.5281 7.67512C1.53903 7.69514 1.54997 7.70788 1.55653 7.71516C1.56957 7.71226 1.58236 7.70861 1.5948 7.70424C1.74462 7.65328 1.98301 7.49037 2.28921 7.18367C2.46335 7.00623 2.62755 6.82219 2.7813 6.63215V6.63215ZM4.57472 5.42173C4.93987 5.35074 5.30834 5.29214 5.67921 5.24608C5.48 4.99253 5.29393 4.73201 5.1215 4.46522C4.95001 4.78794 4.76768 5.1066 4.57472 5.42081V5.42173ZM7.24954 5.83127C7.41357 5.9787 7.57323 6.1043 7.72524 6.20441C7.98769 6.37732 8.17031 6.43466 8.26982 6.43739C8.29647 6.44029 8.3235 6.43547 8.34637 6.42374C8.39186 6.39384 8.42728 6.35465 8.44916 6.30998C8.48804 6.25454 8.51018 6.19208 8.51368 6.12796C8.51305 6.10658 8.50292 6.08615 8.48525 6.07062C8.42839 6.0142 8.26654 5.93229 7.91879 5.88041C7.69759 5.84964 7.47381 5.83351 7.24954 5.83218V5.83127ZM5.07338 2.64048C5.16542 2.39341 5.23847 2.14171 5.29209 1.88692C5.32599 1.71582 5.33911 1.57476 5.33364 1.46372C5.33395 1.40247 5.32212 1.34159 5.29865 1.28353C5.24395 1.28916 5.19053 1.30143 5.14009 1.31993C5.04495 1.35178 4.96731 1.4164 4.92575 1.57749C4.88201 1.75222 4.89294 2.00432 4.97605 2.32558C5.0023 2.4266 5.03511 2.53218 5.07447 2.64048H5.07338Z"
          :fill="color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "IconFileFormat",
  props: {
    width: {
      type: [Number, String],
      default: 12,
    },
    height: {
      type: [Number, String],
      default: 12,
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    jpg: Boolean,
    png: Boolean,
    pdf: Boolean,
    row: Boolean,
  },
}
</script>

<style scoped lang="scss">
svg {
  margin: 0 !important;
}

.flex-gap-1 {
  gap: 2px
}
</style>